import axios from 'axios';
import AuthService from '../../modules/Admin/services/AuthService';

const API_URL = process.env.REACT_APP_API_URL;
export const SUBSCRIPTION_BLOCKED_KEY = 'nf_subscription_blocked_v1';

let inflight = null;
let cachedActive = null;

export function isSubscriptionBlocked() {
  try {
    return sessionStorage.getItem(SUBSCRIPTION_BLOCKED_KEY) === '1';
  } catch {
    return false;
  }
}

export function markSubscriptionInactive() {
  cachedActive = false;
  try {
    sessionStorage.setItem(SUBSCRIPTION_BLOCKED_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function clearSubscriptionBlocked() {
  cachedActive = null;
  inflight = null;
  try {
    sessionStorage.removeItem(SUBSCRIPTION_BLOCKED_KEY);
  } catch {
    /* ignore */
  }
}

export function isSubscriptionBypassUrl(url = '') {
  const u = String(url);
  return (
    u.includes('/Subscription/GetMySubscriptionStatus') ||
    u.includes('/Login/Login') ||
    u.includes('/Login/RefreshTokens') ||
    u.includes('/Login/LogOut')
  );
}

/** Returns true when tenant may use the app; SuperAdmin always true. */
export async function checkTenantSubscriptionActive() {
  const role = AuthService.getLoggedInRoleId();
  if (role === 1 || Number.isNaN(Number(role))) {
    clearSubscriptionBlocked();
    return true;
  }

  const clientId = AuthService.getLoggedInClientId();
  if (!clientId) return true;

  try {
    const res = await axios.get(`${API_URL}/Subscription/GetMySubscriptionStatus`);
    const active = !!res.data?.hasActiveSubscription;
    if (active) {
      clearSubscriptionBlocked();
      cachedActive = true;
    } else {
      markSubscriptionInactive();
    }
    return active;
  } catch (error) {
    if (error.response?.status === 402) {
      markSubscriptionInactive();
      return false;
    }
    return true;
  }
}

export function ensureSubscriptionChecked() {
  const role = AuthService.getLoggedInRoleId();
  if (role === 1 || !AuthService.getLoggedInClientId()) {
    return Promise.resolve(true);
  }
  if (isSubscriptionBlocked()) return Promise.resolve(false);
  if (cachedActive === true) return Promise.resolve(true);
  if (!inflight) {
    inflight = checkTenantSubscriptionActive()
      .catch(() => true)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}
